import { c as _c } from "react/compiler-runtime";
import { FormSelectDataType, getContactFieldTitle, Hint, useTranslation as useUiTranslation } from '@systemeio/ui';
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields';
import { SubstituteInterface } from 'shared/components/dashboard-mail-editor/components/substitutes-block';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const useSubstitutes = t0 => {
  const $ = _c(21);
  const additionalSubstitutes = t0 === undefined ? [] : t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    fields: substitutes
  } = useContactFields();
  const additionalSubstitutionData = additionalSubstitutes.map(_temp);
  let t1;
  if ($[0] !== tUi) {
    t1 = el_0 => ({
      id: `{${el_0.slug}}`,
      caption: getContactFieldTitle(el_0, tUi)
    });
    $[0] = tUi;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contactSubstitutionData = (substitutes?.items ?? []).map(t1);
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.email.contact_affiliate_id");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      caption: t2,
      id: "{affiliate_id}"
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("dashboard.email.contact_affiliate_url");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      a: <span className="block pl-3" />,
      b: <b />
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] !== t) {
    t6 = <TransLoco t={t} i18nKey="dashboard.email.clickable_url_description" components={t5} />;
    t7 = t("dashboard.email.contact_affiliate_url");
    $[9] = t;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <Hint label={t6}>{t7}</Hint>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t8) {
    t9 = {
      caption: t4,
      customCaption: t8,
      id: "{affiliate_dashboard}"
    };
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t9) {
    t10 = [t3, t9];
    $[18] = t3;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const affiliateSubstitutionData = t10;
  const substitutionData = [...additionalSubstitutionData, ...contactSubstitutionData, ...affiliateSubstitutionData];
  const isReady = !!substitutes;
  return {
    substitutionData,
    isReady
  };
};
function _temp(el) {
  return {
    id: `{${el.slug}}`,
    caption: el.name
  };
}